<template>
  <div>
    <div class="page-header page-header-kyc">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-lg-8 col-xl-7 text-center">
            <h2 class="page-title">Begin your ID-Verification</h2>
            <p class="large">Verify your identity to complete KYC</p>
          </div>
        </div>
      </div>
      <!-- .container -->
    </div>
    <div class="page-content">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-lg-12 col-xl-12 col-md-10 col-xs-12">
            <div class="kyc-form-steps card mx-lg-4">
              <div class="form-step form-step1">
                <div class="form-step-head card-innr">
                  <div class="step-head">
                    <div class="step-number">01</div>
                    <div class="step-head-text">
                      <h4>Personal Details</h4>
                      <p>
                        Your simple personal information required for
                        identification
                      </p>
                    </div>
                  </div>
                </div>
                <!-- .step-head -->
                <div class="form-step-fields card-innr">
                  <div class="note note-plane note-light-alt note-md pdb-1x">
                    <em class="fas fa-info-circle"></em>
                    <p>
                      Please type carefully and fill out the form with your
                      personal details. Your can’t edit these details once you
                      submitted the form.
                    </p>
                  </div>
                  <form>
                    <div class="row">
                      <div class="col-md-6">
                        <div class="input-item input-with-label form-group">
                          <label class="input-item-label">
                            First Name
                            <span class="text-danger">*</span>
                          </label>

                          <input
                            v-model="fname"
                            class="form-control"
                            :class="{
                              'is-invalid': submitted && $v.fname.$error,
                            }"
                            type="text"
                          />
                          <div
                            v-if="submitted && !$v.fname.required"
                            class="invalid-feedback"
                          >
                            First Name is required
                          </div>
                        </div>
                        <!-- .input-item -->
                      </div>
                      <!-- .col -->
                      <div class="col-md-6">
                        <div class="input-item input-with-label">
                          <label class="input-item-label">
                            Last Name
                            <span class="text-danger">*</span>
                          </label>
                          <input
                            v-model="lname"
                            class="form-control"
                            :class="{
                              'is-invalid': submitted && $v.lname.$error,
                            }"
                            type="text"
                          />
                          <div
                            v-if="submitted && !$v.lname.required"
                            class="invalid-feedback"
                          >
                            Last Name is required
                          </div>
                        </div>
                        <!-- .input-item -->
                      </div>
                      <!-- .col -->
                      <div class="col-md-6">
                        <div class="input-item input-with-label">
                          <label class="input-item-label">
                            Email Address
                            <span class="text-danger">*</span>
                          </label>
                          <input
                            :class="{
                              'is-invalid': submitted && $v.email.$error,
                            }"
                            v-model="email"
                            class="form-control"
                            type="email"
                          />

                          <div
                            v-if="submitted && $v.email.$error"
                            class="invalid-feedback"
                          >
                            <span v-if="!$v.email.required"
                              >Email is required</span
                            >
                            <span v-if="!$v.email.email">Email is invalid</span>
                          </div>
                        </div>
                        <!-- .input-item -->
                      </div>
                      <!-- .col -->
                      <div class="col-md-6">
                        <div class="input-item input-with-label">
                          <label class="input-item-label">
                            Phone Number
                            <span class="text-danger">*</span>
                          </label>
                          <input
                            :class="{
                              'is-invalid': submitted && $v.mNo.$error,
                            }"
                            v-model="mNo"
                            class="input-bordered form-control"
                            type="number"
                          />
                          <small class="form-text text-muted"
                            >Please enter your phone number with country
                            code</small
                          >
                          <div
                            v-if="submitted && !$v.mNo.required"
                            class="invalid-feedback"
                          >
                            Phone number is required
                          </div>
                        </div>
                        <!-- .input-item -->
                      </div>
                      <!-- .col -->
                      <div class="col-md-6">
                        <div class="input-item input-with-label">
                          <label class="input-item-label">
                            Date of Birth
                            <span class="text-danger">*</span>
                          </label>
                          <br />
                          <date-picker
                            valueType="MM/DD/YYYY"
                            style="border:0;width:auto;right:3%;margin-bottom:15px;"
                            v-model="dob"
                            :class="{
                              'is-invalid': submitted && $v.dob.$error,
                            }"
                            class="form-control"
                            type="date"
                          />
                          <small class="form-text text-muted"
                            >(YYYY-MM-DD format)</small
                          >
                          <div
                            v-if="submitted && !$v.dob.required"
                            class="invalid-feedback"
                          >
                            Date is required
                          </div>
                        </div>

                        <!-- .input-item -->
                      </div>

                      <!-- .input-item -->

                      <!-- .col -->
                      <!-- <div class="col-md-6">
                      <div class="input-item input-with-label">
                        <label class="input-item-label">Telegram Username</label>
                        <input class="input-bordered" type="text">
                      </div>
                     
                      </div>-->
                      <!-- .col -->
                    </div>
                    <!-- .row -->
                    <h4 class="text-secondary mgt-0-5x">Your Address</h4>
                    <div class="row">
                      <div class="col-md-6">
                        <div class="input-item input-with-label">
                          <label class="input-item-label">
                            Address Line 1
                            <span class="text-danger">*</span>
                          </label>
                          <input
                            :class="{
                              'is-invalid': submitted && $v.addr1.$error,
                            }"
                            v-model="addr1"
                            class="input-bordered form-control"
                            type="text"
                          />
                          <div
                            v-if="submitted && !$v.addr1.required"
                            class="invalid-feedback"
                          >
                            Address is required
                          </div>
                        </div>
                        <!-- .input-item -->
                      </div>
                      <!-- .col -->
                      <div class="col-md-6">
                        <div class="input-item input-with-label">
                          <label class="input-item-label">Address Line 2</label>
                          <input
                            v-model="addr2"
                            class="input-bordered form-control"
                            type="text"
                          />

                          <!-- .input-item -->
                        </div>
                      </div>

                      <!-- .col -->
                      <div class="col-md-6">
                        <div class="input-item input-with-label">
                          <label class="input-item-label">
                            City
                            <span class="text-danger">*</span>
                          </label>
                          <input
                            :class="{
                              'is-invalid': submitted && $v.city.$error,
                            }"
                            v-model="city"
                            class="input-bordered form-control"
                            type="text"
                          />
                          <div
                            v-if="submitted && !$v.city.required"
                            class="invalid-feedback"
                          >
                            City is required
                          </div>
                          <!-- .input-item -->
                        </div>
                      </div>

                      <!-- .col -->
                      <div class="col-md-6">
                        <div class="input-item input-with-label">
                          <label class="input-item-label">
                            State
                            <span class="text-danger">*</span>
                          </label>
                          <input
                            v-model="state"
                            :class="{
                              'is-invalid': submitted && $v.state.$error,
                            }"
                            class="input-bordered form-control"
                            type="text"
                          />

                          <div
                            v-if="submitted && !$v.state.required"
                            class="invalid-feedback"
                          >
                            State is required
                          </div>
                        </div>

                        <!-- .input-item -->
                      </div>
                      <!-- .col -->
                      <div class="col-md-6">
                        <div class="input-item input-with-label">
                          <label for="nationality" class="input-item-label">
                            Nationality
                            <span class="text-danger">*</span>
                          </label>
                          <select
                            class="form-control"
                            :class="{
                              'is-invalid':
                                submitted && $v.selectedCountry.$error,
                            }"
                            name="nationality"
                            v-model="country"
                            @change="setCountry(country)"
                            id="nationality"
                          >
                            <option value disabled selected
                              >Choose your option</option
                            >
                            <option
                              :value="data.code"
                              v-for="(data, index) in list"
                              :key="index"
                              >{{ data.name }}</option
                            >
                            <!-- <option value="us">United State</option>
                          <option value="uk">United KingDom</option>
                          <option value="fr">France</option>
                          <option value="ch">China</option>
                          <option value="cr">Czech Republic</option>
                            <option value="cb">Colombia</option>-->
                          </select>
                          <div
                            v-if="submitted && !$v.selectedCountry.required"
                            class="invalid-feedback"
                          >
                            Country is required
                          </div>
                        </div>
                        <!-- .input-item -->
                      </div>
                      <!-- .col -->
                      <div class="col-md-6">
                        <div class="input-item input-with-label">
                          <label class="input-item-label">
                            Zip Code
                            <span class="text-danger">*</span>
                          </label>
                          <input
                            :class="{
                              'is-invalid': submitted && $v.zip.$error,
                            }"
                            v-model="zip"
                            class="input-bordered form-control"
                            type="text"
                          />

                          <div
                            v-if="submitted && !$v.zip.required"
                            class="invalid-feedback"
                          >
                            zip code is required
                          </div>
                        </div>
                        <!-- .input-item -->
                      </div>
                      <!-- .col -->
                    </div>
                  </form>
                  <!-- .row -->
                </div>
                <!-- .step-fields -->
              </div>
              <div
                v-if="passportAllowed || nationalAllowed || drivingAllowed"
                class="form-step form-step2"
              >
                <div class="form-step-head card-innr">
                  <div class="step-head">
                    <div class="step-number">02</div>
                    <div class="step-head-text">
                      <h4>Document Upload</h4>
                      <p>
                        To verify your identity, please upload any of your
                        document
                      </p>
                    </div>
                  </div>
                </div>
                <!-- .step-head -->
                <div class="form-step-fields card-innr">
                  <div class="note note-plane note-light-alt note-md pdb-0-5x">
                    <em class="fas fa-info-circle"></em>
                    <p>
                      In order to complete, please upload any of the following
                      personal document.
                    </p>
                  </div>
                  <div class="gaps-2x"></div>
                  <ul
                    class="nav nav-tabs nav-tabs-bordered row flex-wrap guttar-20px"
                    role="tablist"
                  >
                    <li
                      v-if="passportAllowed"
                      @click="setType('Passport')"
                      class="nav-item flex-grow-0"
                    >
                      <a
                        class="nav-link d-flex align-items-center active"
                        data-toggle="tab"
                        href="#passport"
                      >
                        <div class="nav-tabs-icon">
                          <img
                            src="../assets/images/icon-passport.png"
                            alt="icon"
                          />
                          <img
                            src="../assets/images/icon-passport-color.png"
                            alt="icon"
                          />
                        </div>
                        <span>Passport</span>
                      </a>
                    </li>
                    <li
                      v-if="nationalAllowed"
                      @click="setType('National ID')"
                      class="nav-item flex-grow-0"
                    >
                      <a
                        class="nav-link d-flex align-items-center"
                        data-toggle="tab"
                        href="#national-card"
                      >
                        <div class="nav-tabs-icon">
                          <img
                            src="../assets/images/icon-national-id.png"
                            alt="icon"
                          />
                          <img
                            src="../assets/images/icon-national-id-color.png"
                            alt="icon"
                          />
                        </div>
                        <span>National Card</span>
                      </a>
                    </li>
                    <li
                      v-if="drivingAllowed"
                      @click="setType('Driving Licence')"
                      class="nav-item flex-grow-0"
                    >
                      <a
                        class="nav-link d-flex align-items-center"
                        data-toggle="tab"
                        href="#driver-licence"
                      >
                        <div class="nav-tabs-icon">
                          <img
                            src="../assets/images/icon-licence.png"
                            alt="icon"
                          />
                          <img
                            src="../assets/images/icon-licence-color.png"
                            alt="icon"
                          />
                        </div>
                        <span>Driver’s License</span>
                      </a>
                    </li>
                    <!-- <li @click="setType('Residence Permit')" class="nav-item flex-grow-0">
                      <a
                        class="nav-link d-flex align-items-center"
                        data-toggle="tab"
                        href="#residence-permit"
                      >
                        <div class="nav-tabs-icon">
                          <img src="../assets/images/icon-national-id.png" alt="icon">
                          <img src="../assets/images/icon-national-id-color.png" alt="icon">
                        </div>
                        <span>Residence permit</span>
                      </a>
                    </li> -->
                  </ul>
                  <!-- .nav-tabs-line -->
                  <div class="tab-content" id="myTabContent">
                    <div class="tab-pane fade show active" id="passport">
                      <h5 class="text-secondary font-bold">
                        To avoid delays when verifying account, Please make sure
                        bellow:
                      </h5>
                      <ul class="list-check">
                        <li>Chosen credential must not be expired.</li>
                        <li>
                          Document should be good condition and clearly visible.
                        </li>
                        <li>
                          Make sure that there is no light glare on the card.
                        </li>
                        <a target="_blank" href="./notes.pdf"
                          ><span class="font-weight-bold">Click here</span> to
                          know more about document rules</a
                        >
                      </ul>
                      <div class="gaps-2x"></div>
                      <div class="col-md-6 mt-1 ml-0 pl-0">
                        <div class="input-item input-with-label">
                          <label class="input-item-label">
                            Passport Number
                            <span class="text-danger">*</span>
                          </label>
                          <input
                            :class="{
                              'is-invalid': submitted && $v.IDNo.$error,
                            }"
                            v-model="IDNo"
                            class="input-bordered form-control"
                            type="text"
                          />

                          <div
                            v-if="submitted && !$v.IDNo.required"
                            class="invalid-feedback"
                          >
                            Passport number required
                          </div>
                        </div>
                        <!-- .input-item -->
                      </div>
                      <h5 class="font-mid">Upload Here Your Passport Copy</h5>
                      <div class="row align-items-center">
                        <div class="col-sm-8">
                          <div>
                            <div class="upload-style">
                              <div v-if="!passImage">
                                <input
                                  accept="image/x-png, image/gif, image/jpeg"
                                  id="file"
                                  type="file"
                                  class="form-control"
                                  :class="{
                                    'is-invalid':
                                      submitted && $v.passImage.$error,
                                  }"
                                  @change="onFileChangePass"
                                />
                                <div
                                  v-if="submitted && !$v.passImage.required"
                                  class="invalid-feedback"
                                >
                                  Image is required
                                </div>
                              </div>
                              <div v-else>
                                <img id="imgstyle" :src="passImage" />
                                <button
                                  class="btn btn-primary"
                                  @click="removeImagePass"
                                >
                                  Remove image
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="col-sm-4 d-none d-sm-block">
                          <div class="mx-md-4">
                            <img
                              src="../assets/images/vector-passport.png"
                              alt="vector"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- .tab-pane -->
                    <div class="tab-pane fade" id="national-card">
                      <h5 class="text-secondary font-bold">
                        To avoid delays when verifying account, Please make sure
                        bellow:
                      </h5>
                      <ul class="list-check">
                        <li>Chosen credential must not be expired.</li>
                        <li>
                          Document should be good condition and clearly visible.
                        </li>
                        <li>
                          Make sure that there is no light glare on the card.
                        </li>
                        <a target="_blank" href="./notes.pdf"
                          ><span class="font-weight-bold">Click here</span> to
                          know more about document rules</a
                        >
                      </ul>
                      <div class="gaps-2x"></div>
                      <div class="col-md-6 mt-1 ml-0 pl-0">
                        <div class="input-item input-with-label">
                          <label class="input-item-label">
                            National ID Number
                            <span class="text-danger">*</span>
                          </label>
                          <input
                            :class="{
                              'is-invalid': submitted && $v.IDNo.$error,
                            }"
                            v-model="IDNo"
                            class="input-bordered form-control"
                            type="text"
                          />

                          <div
                            v-if="submitted && !$v.IDNo.required"
                            class="invalid-feedback"
                          >
                            ID number required
                          </div>
                        </div>
                        <!-- .input-item -->
                      </div>
                      <h5 class="font-mid">
                        Upload Here Your National id Front Side
                      </h5>
                      <div class="row align-items-center">
                        <div class="col-sm-8">
                          <div>
                            <div class="upload-style">
                              <div v-if="!nationalImage1">
                                <input
                                  accept="image/x-png, image/gif, image/jpeg"
                                  id="file"
                                  type="file"
                                  class="form-control"
                                  :class="{
                                    'is-invalid':
                                      submitted && $v.nationalImage1.$error,
                                  }"
                                  @change="onFileChangeNational1"
                                />
                                <div
                                  v-if="
                                    submitted && !$v.nationalImage1.requireImage
                                  "
                                  class="invalid-feedback"
                                >
                                  Image is required
                                </div>
                              </div>
                              <div v-else>
                                <img id="imgstyle" :src="nationalImage1" />
                                <button
                                  class="btn btn-primary"
                                  @click="removeImageNational1"
                                >
                                  Remove image
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="col-sm-4 d-none d-sm-block">
                          <div class="mx-md-4">
                            <img
                              src="../assets/images/vector-id-front.png"
                              alt="vector"
                            />
                          </div>
                        </div>
                      </div>
                      <div class="gaps-3x"></div>
                      <h5 class="font-mid">
                        Upload Here Your National id Back Side
                      </h5>
                      <div class="row align-items-center">
                        <div class="col-sm-8">
                          <div>
                            <div class="upload-style">
                              <div v-if="!nationalImage2">
                                <input
                                  accept="image/x-png, image/gif, image/jpeg"
                                  id="file"
                                  type="file"
                                  class="form-control"
                                  :class="{
                                    'is-invalid':
                                      submitted && $v.nationalImage2.$error,
                                  }"
                                  @change="onFileChangeNational2"
                                />
                                <div
                                  v-if="
                                    submitted && !$v.nationalImage2.requireImage
                                  "
                                  class="invalid-feedback"
                                >
                                  Image is required
                                </div>
                              </div>
                              <div v-else>
                                <img id="imgstyle" :src="nationalImage2" />
                                <button
                                  class="btn btn-primary"
                                  @click="removeImageNational2"
                                >
                                  Remove image
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="col-sm-4 d-none d-sm-block">
                          <div class="mx-md-4">
                            <img
                              src="../assets/images/vector-id-back.png"
                              alt="vector"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- .tab-pane -->
                    <div class="tab-pane fade" id="driver-licence">
                      <h5 class="text-secondary font-bold">
                        To avoid delays when verifying account, Please make sure
                        bellow:
                      </h5>
                      <ul class="list-check">
                        <li>Chosen credential must not be expired.</li>
                        <li>
                          Document should be good condition and clearly visible.
                        </li>
                        <li>
                          Make sure that there is no light glare on the card.
                        </li>
                        <a target="_blank" href="./notes.pdf"
                          ><span class="font-weight-bold">Click here</span> to
                          know more about document rules</a
                        >
                      </ul>
                      <div class="gaps-2x"></div>
                      <div class="col-md-6 mt-1 ml-0 pl-0">
                        <div class="input-item input-with-label">
                          <label class="input-item-label">
                            Driving License Number
                            <span class="text-danger">*</span>
                          </label>
                          <input
                            :class="{
                              'is-invalid': submitted && $v.IDNo.$error,
                            }"
                            v-model="IDNo"
                            class="input-bordered form-control"
                            type="text"
                          />

                          <div
                            v-if="submitted && !$v.IDNo.required"
                            class="invalid-feedback"
                          >
                            License number required
                          </div>
                        </div>
                        <!-- .input-item -->
                      </div>
                      <h5 class="font-mid">
                        Upload Here Your Driving Licence Copy
                      </h5>
                      <div class="row align-items-center">
                        <div class="col-sm-8">
                          <div>
                            <div class="upload-style">
                              <div v-if="!drivingImage">
                                <input
                                  accept="image/x-png, image/gif, image/jpeg"
                                  id="file"
                                  type="file"
                                  class="form-control"
                                  :class="{
                                    'is-invalid':
                                      submitted && $v.drivingImage.$error,
                                  }"
                                  @change="onFileChangeDriving"
                                />
                                <div
                                  v-if="
                                    submitted && !$v.drivingImage.requireImage
                                  "
                                  class="invalid-feedback"
                                >
                                  Image is required
                                </div>
                              </div>
                              <div v-else>
                                <img id="imgstyle" :src="drivingImage" />
                                <button
                                  class="btn btn-primary"
                                  @click="removeImageDriving"
                                >
                                  Remove image
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="col-sm-4 d-none d-sm-block">
                          <div class="mx-md-4">
                            <img
                              src="../assets/images/vector-licence.png"
                              alt="vector"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- .tab-pane -->
                  </div>
                  <!-- .tab-content -->
                </div>
                <!-- .step-fields -->
              </div>

              <div class="form-step form-step3">
                <div class="form-step-head card-innr">
                  <div class="step-head">
                    <div class="step-number">03</div>
                    <div class="step-head-text">
                      <h4>Selfie Upload</h4>
                      <p>
                        To verify your identity, Please take a selfie with the
                        given details in an image so that it's clearly visible
                        and does not cover your face
                      </p>
                    </div>
                  </div>
                </div>
                <div class="gaps-2x"></div>
                <div class="form-step-fields card-innr">
                  <div class="col-md-12 mt-1 ml-0 pl-0">
                    <div
                      class="note note-plane note-light-alt note-md pdb-0-5x"
                    >
                      <em class="fas fa-info-circle"></em>
                      <p>
                        Our algorithm will compare your face in the selfie to
                        the document photo. Make sure to upload a bright photo
                        where all text is clearly readable.
                      </p>
                    </div>

                    <!-- .input-item -->
                  </div>
                  <h5 class="text-secondary font-bold">
                    To avoid delays when verifying account, Please make sure
                    bellow:
                  </h5>
                  <ul class="list-check">
                    <li>
                      Please write the randomly generated 8-digit security code
                      below in the middle of the paper with the big text size.
                    </li>

                    <li>
                      Make sure that there is no light glare on the paper.
                    </li>
                    <a target="_blank" href="./selfie.png"
                      ><span class="font-weight-bold">Click here</span> to see
                      the example</a
                    >
                  </ul>
                  <h5 class="font-mid mb-1">Genrated Security code</h5>
                  <div class="mb-4">
                    <h5 style="color:black;font-size:28px">
                      {{ randomNumber }}
                    </h5>
                    <!-- <span class="btn btn-primary" @click="generateNumber">Generate</span> -->
                  </div>

                  <h5 class="font-mid">Upload Here Your selfie image</h5>
                  <div class="row align-items-center">
                    <div class="col-sm-6">
                      <div>
                        <div class="upload-style">
                          <div v-if="!selfieImage">
                            <input
                              accept="image/x-png, image/jpeg"
                              id="file"
                              type="file"
                              capture="camera"
                              class="form-control"
                              :class="{
                                'is-invalid':
                                  submitted && $v.selfieImage.$error,
                              }"
                              @change="onFileChangeSelfie"
                            />

                            <div
                              v-if="submitted && !$v.selfieImage.required"
                              class="invalid-feedback"
                            >
                              Image is required
                            </div>
                          </div>
                          <div v-else>
                            <img id="imgstyle" :src="selfieImage" />
                            <button
                              class="btn btn-primary"
                              @click="removeImageSelfie"
                            >
                              Remove image
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-sm-6 mt-sm-2 d-none d-sm-block">
                      <div class="mx-md-6">
                        <img src="../assets/selfie.png" alt="vector" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-step mt-4 form-step4">
                <div class="form-step-head card-innr">
                  <div class="step-head">
                    <div class="step-number">04</div>
                    <div class="step-head-text">
                      <h4>Consumer Party</h4>
                      <p>
                        Submit the name of the party that's going to access your
                        KYC details
                      </p>
                    </div>
                  </div>
                </div>
                <!-- .step-head -->
                <div class="form-step-fields card-innr">
                  <!-- .row -->
                  <div class="col-md-6">
                    <div class="input-item input-with-label">
                      <label for="nationality" class="input-item-label">
                        Party
                        <span class="text-danger">*</span>
                      </label>
                      <select
                        class="form-control"
                        :disabled="disabled"
                        ref="partyName"
                        :class="{ 'is-invalid': submitted && $v.party.$error }"
                        v-model="party"
                        @change="showDialog"
                      >
                        <option value disabled selected
                          >Choose your option</option
                        >
                        <option
                          :value="data"
                          v-for="(data, index) in parties"
                          :key="index"
                          >{{ data }}</option
                        >
                        <!-- <option value="us">United State</option>
                          <option value="uk">United KingDom</option>
                          <option value="fr">France</option>
                          <option value="ch">China</option>
                          <option value="cr">Czech Republic</option>
                        <option value="cb">Colombia</option>-->
                      </select>
                      <div
                        v-if="submitted && !$v.party.required"
                        class="invalid-feedback"
                      >
                        Party is required
                      </div>
                    </div>
                  </div>
                  <!-- .input-item -->
                </div>
                <!-- .step-fields -->
              </div>
              <div class="form-step form-step-final">
                <div class="form-step-fields card-innr">
                  <!-- <div class="input-item">
                    <input
                      v-model="agree1"
                      class="input-checkbox input-checkbox-md form-control"
                      :class="{ 'is-invalid': submitted && $v.agree1.$error }"
                      id="term-condition"
                      type="checkbox"
                    >
                    <label for="term-condition">
                      I have read the
                      <a href="#">Terms of Condition</a> and
                      <a href="#">Privary Policy.</a>
                    </label>
                    <div
                      v-if="submitted && !$v.agree1.required"
                      class="invalid-feedback"
                    >Agreetment is required</div>
                  </div> -->
                  <div>
                    <div class="input-item">
                      <input
                        :class="{ 'is-invalid': submitted && $v.agree1.$error }"
                        @change="agree1 = !agree1"
                        class="input-checkbox input-checkbox-md form-control"
                        id="info-currect"
                        type="checkbox"
                      />
                      <label for="info-currect"
                        >All the personal information I have entered is
                        correct.</label
                      >
                      <div
                        v-if="submitted && !$v.agree1.required"
                        class="invalid-feedback"
                      >
                        Agreetment is required
                      </div>
                    </div>
                  </div>

                  <div class="input-item">
                    <input
                      :class="{ 'is-invalid': submitted && $v.agree2.$error }"
                      @change="agree2 = !agree2"
                      class="input-checkbox input-checkbox-md form-control"
                      id="info-correct1"
                      type="checkbox"
                    />
                    <label for="info-correct1"
                      >I confirm that i have read and agree to the KYC.Crypto
                      <a
                        style="text-decoration:none;color:#25CAE5;"
                        href="https://kyc-crypto.com/terms"
                        target="_blank"
                        >Terms of Service</a
                      >
                      and
                      <a
                        href="https://kyc-crypto.com/privacy"
                        style="text-decoration:none;color:#25CAE5;"
                        target="_blank"
                        >Privacy Policy</a
                      >
                      , and I am of legal age.</label
                    >
                    <div
                      v-if="submitted && !$v.agree2.required"
                      class="invalid-feedback"
                    >
                      Agreetment is required
                    </div>

                    <div class="gaps-1x mt-2"></div>
                    <p @click="handleSubmit" class="btn btn-primary">
                      Process for
                    </p>
                  </div>

                  <!-- .step-fields -->
                </div>
              </div>

              <!-- .card -->
            </div>
          </div>
        </div>

        <!-- .container -->
      </div>
    </div>
    <div data-backdrop="false" class="modal fade" id="myModal">
      <div class="modal-dialog">
        -->
        <div class="modal-content">
          <!-- Modal Header -->
          <div class="modal-header">
            <h4 class="modal-title">
              Verify your email address (OTP has been sent to {{ email }})
            </h4>
            <button type="button" class="close" data-dismiss="modal">
              &times;
            </button>
          </div>

          <!-- Modal body -->
          <div class="modal-body">
            <div class="input-item input-with-label">
              <label class="input-item-label">
                OTP
                <span class="text-danger">*</span>
              </label>
              <input v-model="otp" class="input-bordered" type="text" />
            </div>
          </div>

          <!-- Modal footer -->
          <div class="modal-footer">
            <button @click="verifyOtp" type="button" class="btn btn-success">
              Submit
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- .page-header -->

    <div data-backdrop="false" class="modal fade" id="partyModal">
      <div class="modal-dialog">
        <div class="modal-content">
          <!-- Modal Header -->
          <div class="modal-header">
            <h4 class="modal-title">Party Details</h4>
          </div>

          <!-- Modal body -->
          <div class="modal-body">
            <h6>Party name: {{ partyDetails.partyName }}</h6>
            <hr />
            <h6>Email address: {{ partyDetails.email }}</h6>
            <hr />
            <h6>Address: {{ partyDetails.address }}</h6>
            <hr />
            <h6>City: {{ partyDetails.city }}</h6>
            <hr />
            <h6>Zip code: {{ partyDetails.zipCode }}</h6>
            <hr />

            <h6>Country: {{ partyDetails.country }}</h6>
          </div>

          <!-- Modal footer -->
          <div class="modal-footer">
            <button
              type="button"
              @click="partyDetails = ''"
              class="btn btn-primary"
              data-dismiss="modal"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { required, email } from "vuelidate/lib/validators";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import { WebCam } from "vue-web-cam";

import axios from "axios";

export default {
  name: "KYCForm",
  components: { DatePicker, WebCam },
  data() {
    return {
      disabled: false,
      randomNumber: 0,
      web3: this.$store.state.web3,
      currentAddress: this.$cookies.get("address"),

      selfieImage: "",
      passImage: "",
      nationalImage1: "",
      nationalImage2: "",
      drivingImage: "",
      partyDetails: "",
      passportAllowed: false,
      nationalAllowed: false,
      drivingAllowed: false,
      noPermit: false,
      party: "",

      agree2: false,
      agree1: false,
      fname: "",
      lname: "",
      mNo: "",
      email: "",
      country: "",
      dob: "",
      state: "",
      zip: "",
      addr1: "",
      addr2: "",
      city: "",
      IDType: "Passport",
      IDNo: "",
      partnerAddress: "",
      parties: [],
      list: [
        { name: "Afghanistan", code: "AF" },
        { name: "land Islands", code: "AX" },
        { name: "Albania", code: "AL" },
        { name: "Algeria", code: "DZ" },
        { name: "American Samoa", code: "AS" },
        { name: "AndorrA", code: "AD" },
        { name: "Angola", code: "AO" },
        { name: "Anguilla", code: "AI" },
        { name: "Antarctica", code: "AQ" },
        { name: "Antigua and Barbuda", code: "AG" },
        { name: "Argentina", code: "AR" },
        { name: "Armenia", code: "AM" },
        { name: "Aruba", code: "AW" },
        { name: "Australia", code: "AU" },
        { name: "Austria", code: "AT" },
        { name: "Azerbaijan", code: "AZ" },
        { name: "Bahamas", code: "BS" },
        { name: "Bahrain", code: "BH" },
        { name: "Bangladesh", code: "BD" },
        { name: "Barbados", code: "BB" },
        { name: "Belarus", code: "BY" },
        { name: "Belgium", code: "BE" },
        { name: "Belize", code: "BZ" },
        { name: "Benin", code: "BJ" },
        { name: "Bermuda", code: "BM" },
        { name: "Bhutan", code: "BT" },
        { name: "Bolivia", code: "BO" },
        { name: "Bosnia and Herzegovina", code: "BA" },
        { name: "Botswana", code: "BW" },
        { name: "Bouvet Island", code: "BV" },
        { name: "Brazil", code: "BR" },
        { name: "British Indian Ocean Territory", code: "IO" },
        { name: "Brunei Darussalam", code: "BN" },
        { name: "Bulgaria", code: "BG" },
        { name: "Burkina Faso", code: "BF" },
        { name: "Burundi", code: "BI" },
        { name: "Cambodia", code: "KH" },
        { name: "Cameroon", code: "CM" },
        { name: "Canada", code: "CA" },
        { name: "Cape Verde", code: "CV" },
        { name: "Cayman Islands", code: "KY" },
        { name: "Central African Republic", code: "CF" },
        { name: "Chad", code: "TD" },
        { name: "Chile", code: "CL" },
        { name: "China", code: "CN" },
        { name: "Christmas Island", code: "CX" },
        { name: "Cocos (Keeling) Islands", code: "CC" },
        { name: "Colombia", code: "CO" },
        { name: "Comoros", code: "KM" },
        { name: "Congo", code: "CG" },
        { name: "Congo, The Democratic Republic of the", code: "CD" },
        { name: "Cook Islands", code: "CK" },
        { name: "Costa Rica", code: "CR" },
        { name: "Cote D'Ivoire", code: "CI" },
        { name: "Croatia", code: "HR" },
        { name: "Cuba", code: "CU" },
        { name: "Cyprus", code: "CY" },
        { name: "Czech Republic", code: "CZ" },
        { name: "Denmark", code: "DK" },
        { name: "Djibouti", code: "DJ" },
        { name: "Dominica", code: "DM" },
        { name: "Dominican Republic", code: "DO" },
        { name: "Ecuador", code: "EC" },
        { name: "Egypt", code: "EG" },
        { name: "El Salvador", code: "SV" },
        { name: "Equatorial Guinea", code: "GQ" },
        { name: "Eritrea", code: "ER" },
        { name: "Estonia", code: "EE" },
        { name: "Ethiopia", code: "ET" },
        { name: "Falkland Islands (Malvinas)", code: "FK" },
        { name: "Faroe Islands", code: "FO" },
        { name: "Fiji", code: "FJ" },
        { name: "Finland", code: "FI" },
        { name: "France", code: "FR" },
        { name: "French Guiana", code: "GF" },
        { name: "French Polynesia", code: "PF" },
        { name: "French Southern Territories", code: "TF" },
        { name: "Gabon", code: "GA" },
        { name: "Gambia", code: "GM" },
        { name: "Georgia", code: "GE" },
        { name: "Germany", code: "DE" },
        { name: "Ghana", code: "GH" },
        { name: "Gibraltar", code: "GI" },
        { name: "Greece", code: "GR" },
        { name: "Greenland", code: "GL" },
        { name: "Grenada", code: "GD" },
        { name: "Guadeloupe", code: "GP" },
        { name: "Guam", code: "GU" },
        { name: "Guatemala", code: "GT" },
        { name: "Guernsey", code: "GG" },
        { name: "Guinea", code: "GN" },
        { name: "Guinea-Bissau", code: "GW" },
        { name: "Guyana", code: "GY" },
        { name: "Haiti", code: "HT" },
        { name: "Heard Island and Mcdonald Islands", code: "HM" },
        { name: "Holy See (Vatican City State)", code: "VA" },
        { name: "Honduras", code: "HN" },
        { name: "Hong Kong", code: "HK" },
        { name: "Hungary", code: "HU" },
        { name: "Iceland", code: "IS" },
        { name: "India", code: "IN" },
        { name: "Indonesia", code: "ID" },
        { name: "Iran, Islamic Republic Of", code: "IR" },
        { name: "Iraq", code: "IQ" },
        { name: "Ireland", code: "IE" },
        { name: "Isle of Man", code: "IM" },
        { name: "Israel", code: "IL" },
        { name: "Italy", code: "IT" },
        { name: "Jamaica", code: "JM" },
        { name: "Japan", code: "JP" },
        { name: "Jersey", code: "JE" },
        { name: "Jordan", code: "JO" },
        { name: "Kazakhstan", code: "KZ" },
        { name: "Kenya", code: "KE" },
        { name: "Kiribati", code: "KI" },
        { name: "Korea, Democratic People'S Republic of", code: "KP" },
        { name: "Korea, Republic of", code: "KR" },
        { name: "Kuwait", code: "KW" },
        { name: "Kyrgyzstan", code: "KG" },
        { name: "Lao People'S Democratic Republic", code: "LA" },
        { name: "Latvia", code: "LV" },
        { name: "Lebanon", code: "LB" },
        { name: "Lesotho", code: "LS" },
        { name: "Liberia", code: "LR" },
        { name: "Libyan Arab Jamahiriya", code: "LY" },
        { name: "Liechtenstein", code: "LI" },
        { name: "Lithuania", code: "LT" },
        { name: "Luxembourg", code: "LU" },
        { name: "Macao", code: "MO" },
        { name: "Macedonia, The Former Yugoslav Republic of", code: "MK" },
        { name: "Madagascar", code: "MG" },
        { name: "Malawi", code: "MW" },
        { name: "Malaysia", code: "MY" },
        { name: "Maldives", code: "MV" },
        { name: "Mali", code: "ML" },
        { name: "Malta", code: "MT" },
        { name: "Marshall Islands", code: "MH" },
        { name: "Martinique", code: "MQ" },
        { name: "Mauritania", code: "MR" },
        { name: "Mauritius", code: "MU" },
        { name: "Mayotte", code: "YT" },
        { name: "Mexico", code: "MX" },
        { name: "Micronesia, Federated States of", code: "FM" },
        { name: "Moldova, Republic of", code: "MD" },
        { name: "Monaco", code: "MC" },
        { name: "Mongolia", code: "MN" },
        { name: "Montenegro", code: "ME" },
        { name: "Montserrat", code: "MS" },
        { name: "Morocco", code: "MA" },
        { name: "Mozambique", code: "MZ" },
        { name: "Myanmar", code: "MM" },
        { name: "Namibia", code: "NA" },
        { name: "Nauru", code: "NR" },
        { name: "Nepal", code: "NP" },
        { name: "Netherlands", code: "NL" },
        { name: "Netherlands Antilles", code: "AN" },
        { name: "New Caledonia", code: "NC" },
        { name: "New Zealand", code: "NZ" },
        { name: "Nicaragua", code: "NI" },
        { name: "Niger", code: "NE" },
        { name: "Nigeria", code: "NG" },
        { name: "Niue", code: "NU" },
        { name: "Norfolk Island", code: "NF" },
        { name: "Northern Mariana Islands", code: "MP" },
        { name: "Norway", code: "NO" },
        { name: "Oman", code: "OM" },
        { name: "Pakistan", code: "PK" },
        { name: "Palau", code: "PW" },
        { name: "Palestinian Territory, Occupied", code: "PS" },
        { name: "Panama", code: "PA" },
        { name: "Papua New Guinea", code: "PG" },
        { name: "Paraguay", code: "PY" },
        { name: "Peru", code: "PE" },
        { name: "Philippines", code: "PH" },
        { name: "Pitcairn", code: "PN" },
        { name: "Poland", code: "PL" },
        { name: "Portugal", code: "PT" },
        { name: "Puerto Rico", code: "PR" },
        { name: "Qatar", code: "QA" },
        { name: "Reunion", code: "RE" },
        { name: "Romania", code: "RO" },
        { name: "Russian Federation", code: "RU" },
        { name: "RWANDA", code: "RW" },
        { name: "Saint Helena", code: "SH" },
        { name: "Saint Kitts and Nevis", code: "KN" },
        { name: "Saint Lucia", code: "LC" },
        { name: "Saint Pierre and Miquelon", code: "PM" },
        { name: "Saint Vincent and the Grenadines", code: "VC" },
        { name: "Samoa", code: "WS" },
        { name: "San Marino", code: "SM" },
        { name: "Sao Tome and Principe", code: "ST" },
        { name: "Saudi Arabia", code: "SA" },
        { name: "Senegal", code: "SN" },
        { name: "Serbia", code: "RS" },
        { name: "Seychelles", code: "SC" },
        { name: "Sierra Leone", code: "SL" },
        { name: "Singapore", code: "SG" },
        { name: "Slovakia", code: "SK" },
        { name: "Slovenia", code: "SI" },
        { name: "Solomon Islands", code: "SB" },
        { name: "Somalia", code: "SO" },
        { name: "South Africa", code: "ZA" },
        { name: "South Georgia and the South Sandwich Islands", code: "GS" },
        { name: "Spain", code: "ES" },
        { name: "Sri Lanka", code: "LK" },
        { name: "Sudan", code: "SD" },
        { name: "Suriname", code: "SR" },
        { name: "Svalbard and Jan Mayen", code: "SJ" },
        { name: "Swaziland", code: "SZ" },
        { name: "Sweden", code: "SE" },
        { name: "Switzerland", code: "CH" },
        { name: "Syrian Arab Republic", code: "SY" },
        { name: "Taiwan, Province of China", code: "TW" },
        { name: "Tajikistan", code: "TJ" },
        { name: "Tanzania, United Republic of", code: "TZ" },
        { name: "Thailand", code: "TH" },
        { name: "Timor-Leste", code: "TL" },
        { name: "Togo", code: "TG" },
        { name: "Tokelau", code: "TK" },
        { name: "Tonga", code: "TO" },
        { name: "Trinidad and Tobago", code: "TT" },
        { name: "Tunisia", code: "TN" },
        { name: "Turkey", code: "TR" },
        { name: "Turkmenistan", code: "TM" },
        { name: "Turks and Caicos Islands", code: "TC" },
        { name: "Tuvalu", code: "TV" },
        { name: "Uganda", code: "UG" },
        { name: "Ukraine", code: "UA" },
        { name: "United Arab Emirates", code: "AE" },
        { name: "United Kingdom", code: "GB" },
        { name: "United States", code: "US" },
        { name: "United States Minor Outlying Islands", code: "UM" },
        { name: "Uruguay", code: "UY" },
        { name: "Uzbekistan", code: "UZ" },
        { name: "Vanuatu", code: "VU" },
        { name: "Venezuela", code: "VE" },
        { name: "Viet Nam", code: "VN" },
        { name: "Virgin Islands, British", code: "VG" },
        { name: "Virgin Islands, U.S.", code: "VI" },
        { name: "Wallis and Futuna", code: "WF" },
        { name: "Western Sahara", code: "EH" },
        { name: "Yemen", code: "YE" },
        { name: "Zambia", code: "ZM" },
        { name: "Zimbabwe", code: "ZW" },
      ],

      submitted: false,
      showModal: false,
      selectedCountry: "",
      image: "",
      kycId: undefined,
      passImageSubmit: undefined,
      nationalImage1Submit: undefined,
      nationalImage2Submit: undefined,
      drivingImageSubmit: undefined,
      selfieImageSubmit: undefined,
    };
  },
  validations: {
    passImage: {
      requireImage(passImage) {
        //   if (this.IDType == "Passport") {
        //     if (passImage != "") {
        //       console.log("hm");
        //       return true;
        //     }else{
        //       return false;
        //     }
        //   }
        // }
        let dec = true;
        if (this.IDType == "Passport" && passImage == "") {
          dec = false;
        }

        return dec;
      },
    },
    nationalImage1: {
      requireImage(nationalImage1) {
        let dec = true;
        if (
          this.IDType == "National ID" &&
          nationalImage1 == ""
          // this.passImage == "" &&
          // this.drivingImage == ""
        ) {
          // console.log("error national");
          dec = false;
        }
        return dec;
      },
    },
    nationalImage2: {
      requireImage(nationalImage2) {
        let dec = true;
        if (
          this.IDType == "National ID" &&
          nationalImage2 == ""
          // this.passImage == "" &&
          // this.drivingImage == ""
        ) {
          dec = false;
        }
        return dec;
      },
    },
    drivingImage: {
      requireImage(drivingImage) {
        let dec = true;
        if (
          this.IDType == "Driving Licence" &&
          drivingImage == ""

          // this.nationalImage1=="" && this.nationalImage2==""
        ) {
          dec = false;
        }
        return dec;

        // }
      },
    },
    agree1: {
      required() {
        let dec = true;
        if (this.agree1 == false) {
          dec = false;
        }
        return dec;
      },
    },
    agree2: {
      required() {
        let dec = true;
        if (this.agree2 == false) {
          dec = false;
        }
        return dec;
      },
    },
    selfieImage: {
      required,
    },
    fname: { required },
    lname: { required },
    email: { required, email },
    selectedCountry: { required },
    mNo: { required },
    dob: { required },
    state: { required },
    zip: { required },
    addr1: { required },

    city: { required },

    IDNo: { required },
    party: { required },
    // partnerAddress: {
    //   required,
    //   validAddress(partnerAddress) {
    //     return /^0x[a-fA-F0-9]{40}$/g.test(partnerAddress);
    //   }
    // },
    // agree1: {
    //   required
    // },
  },
  methods: {
    not() {
      //     alert('Not')
      this.$refs.webcam.start();
      // this.selfieImage=this.$refs.webcam.capture();
    },

    generateNumber() {
      this.randomNumber = Math.floor(10000000 + Math.random() * 90000000);
    },
    async showDialog(e) {
      e.preventDefault();

      let key = process.env.VUE_APP_API_KEY;
      this.$store.state.loading = true;

      try {
        let data = await axios({
          url: this.$store.state.url + "/api/party?partyName=" + this.party,
          method: "GET",

          headers: {
            Authorization: "Basic " + key,
          },
        });
        this.partyDetails = data.data.data.party;

        window.$("#partyModal").modal({ backdrop: "static", keyboard: false });
      } catch (err) {
        console.log(err);
      } finally {
        this.$store.state.loading = false;
      }
    },
    setCountry(country) {
      let noDriving = [
        "Korea, Democratic People'S Republic of",
        "Libyan Arab Jamahiriya",
        "Holy See (Vatican City State)",
      ];
      let noNational = [
        "AndorrA",
        "Bahamas",
        "Denmark",
        "Iceland",
        "Jersey",
        "Korea, Democratic People'S Republic of",
        "Libyan Arab Jamahiriya",
        "Myanmar",
        "Holy See (Vatican City State)",
      ];
      let noPassport = ["Aruba"];
      for (let i = 0; i < this.list.length; i++) {
        if (this.list[i].code == country) {
          this.selectedCountry = this.list[i].name;
        }
      }
      if (noDriving.indexOf(this.selectedCountry) == -1) {
        this.drivingAllowed = true;
      } else {
        this.drivingAllowed = false;
      }
      if (noNational.indexOf(this.selectedCountry) == -1) {
        this.nationalAllowed = true;
      } else {
        this.nationalAllowed = false;
      }
      if (noPassport.indexOf(this.selectedCountry) == -1) {
        this.passportAllowed = true;
      } else {
        this.passportAllowed = false;
      }

      //  console.log(this.selectedCountry)
    },
    async uploadDocs(kycid) {
      let key = process.env.VUE_APP_API_KEY;
      let formData = new FormData();
      formData.append("trxAddress", this.currentAddress);
      if (this.IDType == "Passport") {
        // console.log("img:",this.passImageSubmit)
        formData.append("passport", this.passImageSubmit);
        formData.append("passport", this.selfieImageSubmit);
      } else if (this.IDType == "National ID") {
        console.log(this.selfieImageSubmit);
        formData.append("national_id", this.nationalImage1Submit);
        formData.append("national_id", this.nationalImage2Submit);
        formData.append("national_id", this.selfieImageSubmit);
      } else {
        // console.log(this.drivingImageSubmit)
        formData.append("other_docs", this.drivingImageSubmit);
        formData.append("other_docs", this.selfieImageSubmit);
      }

      try {
        await axios({
          url: this.$store.state.url + "/api/user/addDocs",
          method: "POST",
          data: formData,

          headers: {
            Authorization: "Basic " + key,
          },
        });

        await this.uploadPescheckDocs(kycid);
      } catch (err) {
        console.log(err.response);
        this.$toasted.global.my_app_error({
          message: err.response.data.error,
        });
      }
      this.$store.state.loading = false;
    },
    async uploadPescheckDocs(kycid) {
      console.log("here kyc id:", kycid);
      let key = process.env.VUE_APP_API_KEY;
      let formData = new FormData();
      formData.append("trxAddress", this.currentAddress);
      formData.append("kycId", kycid);
      if (this.IDType == "Passport") {
        // console.log("img:",this.passImageSubmit)
        formData.append("passport", this.passImageSubmit);
        formData.append("passport", this.selfieImageSubmit);
      } else if (this.IDType == "National ID") {
        formData.append("national_id", this.nationalImage1Submit);
        formData.append("national_id", this.nationalImage2Submit);
        formData.append("national_id", this.selfieImageSubmit);
      } else {
        // console.log(this.drivingImageSubmit)
        formData.append("other_docs", this.drivingImageSubmit);
        formData.append("other_docs", this.selfieImageSubmit);
      }

      try {
        await axios({
          url: this.$store.state.url + "/api/user/addPescheckDocs",
          method: "POST",
          data: formData,

          headers: {
            Authorization: "Basic " + key,
          },
        });
        this.$toasted.global.my_app_success({
          message: "KYC details submitted successfully",
        });

        this.$router.push("/kycDone");
      } catch (err) {
        console.log(err.response);
        this.$toasted.global.my_app_error({
          message: err.response.data.error,
        });
      }
      this.$store.state.loading = false;
    },
    async sendKycData() {
      // console.log(this.selectedCountry)
      let formData = new FormData();
      let data = {
        trxAddress: this.currentAddress,
        fname: this.fname,
        lname: this.lname,
        bdate: this.dob,
        email: this.email,
        address:
          this.addr1 +
          " " +
          this.addr2 +
          ", " +
          this.city +
          ", " +
          this.state +
          ", " +
          this.zip,
        origin_country: this.country,
        birth_country: this.country,
        country: this.selectedCountry,
        pin: this.zip,
        mobile: this.mNo,
        idType: this.IDType,
        idNumber: this.IDNo,
        partyName: this.party,
        kycUpdate: false,
        randomNumber: this.randomNumber,
      };

      let key = process.env.VUE_APP_API_KEY;

      formData.append("trxAddress", data.trxAddress);
      formData.append("fname", data.fname);
      formData.append("lname", data.lname);
      formData.append("bdate", data.bdate);
      formData.append("email", data.email);
      formData.append("address", data.address);
      formData.append("birth_country", data.birth_country);
      formData.append("origin_country", data.origin_country);
      formData.append("country", data.country);
      formData.append("pin", data.pin);
      formData.append("mobile", data.mobile);
      formData.append("idType", data.idType);
      formData.append("idNumber", data.idNumber);
      formData.append("partyName", data.partyName);
      formData.append("kycUpdate", data.kycUpdate);
      formData.append("randomNumber", data.randomNumber);

      if (this.IDType == "Passport") {
        // console.log("img:",this.passImageSubmit)
        formData.append("passport", this.passImageSubmit);
        formData.append("passport", this.selfieImageSubmit);
      } else if (this.IDType == "National ID") {
        console.log(this.selfieImageSubmit);
        formData.append("national_id", this.nationalImage1Submit);
        formData.append("national_id", this.nationalImage2Submit);
        formData.append("national_id", this.selfieImageSubmit);
      } else {
        // console.log(this.drivingImageSubmit)
        formData.append("other_docs", this.drivingImageSubmit);
        formData.append("other_docs", this.selfieImageSubmit);
      }

      try {
        let kycid = await axios({
          url: this.$store.state.url + "/api/user/createKyc",
          method: "POST",
          data: formData,
          headers: {
            Authorization: "Basic " + key,
          },
          withCredentials: true,
        });
        // console.log("kyc id :",kycid);
        // console.log("kyc id:",kycid.data.kycId);
        this.$store.state.loading = false;
        this.$router.push("/kycDone");
        // await this.uploadDocs(kycid.data.kycId);
      } catch (err) {
        console.log(err.response.data.error);
        this.$store.state.loading = false;

        this.$toasted.global.my_app_error({
          message: err.response.data.error,
        });
        this.$store.state.loading = false;
      }
    },

    // async sendKycData() {
    //   // console.log(this.selectedCountry)
    //   let formData= new FormData();
    //   let data = {
    //     trxAddress: this.currentAddress,
    //     fname: this.fname,
    //     lname: this.lname,
    //     bdate: this.dob,
    //     email: this.email,
    //     address:
    //       this.addr1 +
    //       " " +
    //       this.addr2 +
    //       ", " +
    //       this.city +
    //       ", " +
    //       this.state +
    //       ", " +
    //       this.zip,
    //     origin_country: this.country,
    //     birth_country: this.country,
    //     country: this.selectedCountry,
    //     pin: this.zip,
    //     mobile: this.mNo,
    //     idType: this.IDType,
    //     idNumber: this.IDNo,
    //     partyName: this.party,
    //     kycUpdate: false,
    //     randomNumber:this.randomNumber
    //   };

    //   let key = process.env.VUE_APP_API_KEY;

    //   try {
    //     let kycid = await axios({
    //       url: this.$store.state.url + "/api/user/addkyc",
    //       method: "POST",
    //       data: data,

    //       headers: {
    //         Authorization: "Basic " + key,
    //       },
    //       withCredentials: true,
    //     });
    //     console.log("kyc id :",kycid);
    //     console.log("kyc id:",kycid.data.kycId);

    //     await this.uploadDocs(kycid.data.kycId);
    //   } catch (err) {
    //     console.log(err);
    //     this.$store.state.loading = false;

    //     this.$toasted.global.my_app_error({
    //       message: err.response.data.error,
    //     });
    //     this.$store.state.loading = false;
    //   }
    // },
    async checkImage() {
      try {
        this.$store.state.loading = true;
        // let img=new FormData();
        // img.append('file',this.selfieImageSubmit);
        //         var xhr = new XMLHttpRequest();

        // xhr.addEventListener("readystatechange", function () {
        //     if (this.readyState === this.DONE) {
        //         console.log(this.responseText);
        //     }
        // });

        // xhr.open("POST", 'https://app.nanonets.com/api/v2/OCR/Model/'+process.env.VUE_APP_MODEL_ID+'/LabelFile/');
        // xhr.setRequestHeader("authorization", "Basic " + btoa(process.env.VUE_APP_IMG_API_KEY));

        // xhr.send(img);

        // let data = await axios({
        //   url: 'https://app.nanonets.com/api/v2/OCR/Model/'+process.env.VUE_APP_MODEL_ID+'/LabelFile/',
        //   method: "POST",
        //   data:img,
        //   headers: {
        //     Authorization: "Basic " + btoa(process.env.VUE_APP_IMG_API_KEY+":"),
        //   },
        // });
        // console.log("img result:",data);
        // if(data.data.result[0].prediction.length>0){
        // this.randomNumber=parseInt(data.data.result[0].prediction[0].ocr_text)
        // if(parseInt(data.data.result[0].prediction[0].ocr_text)==this.randomNumber &&  data.data.result[0].prediction[0].score>=0.51 ){
        await this.getOTP();
        this.$store.state.loading = false;
        // }else{
        //   this.$store.state.loading = false;
        //     this.$toasted.global.my_app_error({
        //   message:  "Random security code doesn't match with the uploaded selfie , please upload your selfie again!"
        // });
        // }
        // }else{
        //    this.$store.state.loading = false;
        //     this.$toasted.global.my_app_error({
        //   message:  "Random security code doesn't match with the uploaded selfie , please upload your selfie again!"
        // });
        // }
      } catch (err) {
        console.log(err);
      } finally {
      }
    },
    async getOTP() {
      this.email = this.email.toLowerCase().trim();

      let newKey = process.env.VUE_APP_API_KEY;
      let getData = await axios({
        url: this.$store.state.url + "/api/user/setVal",

        method: "POST",
        data: {
          val: this.email,
        },
        headers: {
          Authorization: "Basic " + newKey,
        },
      });
      let encEmail = getData.data.val;
      let usedEmail = await this.$store.state.KYC.getUserAddress(
        encEmail
      ).call();
      // usedEmail=await staticEncrypt(usedEmail);
      console.log(usedEmail);
      if (usedEmail == "410000000000000000000000000000000000000000") {
        let key = process.env.VUE_APP_API_KEY;
        this.$store.state.loading = true;
        try {
          let done = await axios({
            url: this.$store.state.url + "/api/user/sendOtp",
            method: "POST",
            data: {
              email: this.email,
              subject: "email-update",
            },

            headers: {
              Authorization: "Basic " + key,
            },
            withCredentials: true,
          });
          // console.log("done", done);
          if (done.status == 200) {
            window.$("#myModal").modal({ backdrop: "static", keyboard: false });
          }
        } catch (err) {
          this.$store.state.loading = false;
          console.log(err);
          this.$toasted.global.my_app_error({
            message: err.response.data.error,
          });
        }
      } else {
        this.$store.state.loading = false;
        this.$toasted.global.my_app_error({
          message:
            "The given email address is already in use, please use unique email address",
        });
      }
    },

    async verifyOtp() {
      this.$store.state.loading = true;

      try {
        let key = process.env.VUE_APP_API_KEY;

        let done = await axios({
          url: this.$store.state.url + "/api/user/verifyOtp",
          method: "POST",
          data: {
            otp: this.otp,
            subject: "email-update",
            email: this.email,
          },

          headers: {
            Authorization: "Basic " + key,
          },
          withCredentials: true,
        });
        // console.log("done", done);
        if (done.status == 200) {
          this.otp = "";

          window.$("#myModal").modal("hide");
          await this.sendKycData();
          //await this.uploadDocs();
        } else {
          this.$toasted.global.my_app_error({
            message: err.response.data.error,
          });
        }

        this.otp = "";

        window.$("#myModal").modal("hide");
      } catch (err) {
        console.log(err);
        this.$toasted.global.my_app_error({
          message: err.response.data.error,
        });
        this.$store.state.loading = false;
        this.otp = "";
      }
    },
    async getParties(partyName, partyAddress) {
      this.$store.state.loading = true;
      let isParty = await this.$store.state.KYC.isParty(partyAddress).call();
      if (isParty == false) return;

      this.parties.push(partyName.trim());

      // console.log(partyName);
      // amount = await this.$store.state.tronWeb.fromSun(amount.toString());
      // console.log("Amount:",amount)
      // if (isParty) {
      //   let partyDetails = await this.$store.state.KYC
      //     .getPartyDetails()
      //     .call({ from: partyAddress });
      //   if (amount >= 500 && partyDetails.isSpecial == false) {

      //     this.parties.push(partyDetails.partyName);

      //   } else if (partyDetails.isSpecial) {

      //     this.parties.push(partyDetails.partyName);
      //   }
      // }
      this.parties = [...new Set(this.parties)];

      this.$store.state.loading = false;
    },
    submit() {
      // console.log("country:", this.country);
      this.$router.push("kycDone");
    },
    setType(type) {
      // console.log(type)
      this.IDType = type;
      this.IDNo = "";
    },
    async handleSubmit() {
      this.submitted = true;
      console.log(this.dob);
      console.log(this.selfieImageSubmit);
      console.log(this.passImageSubmit);
      this.dob = this.dob
        .toString()
        .replace(/(\d\d)\/(\d\d)\/(\d{4})/, "$3-$1-$2");

      // stop here if form is invalid
      this.$v.$touch();

      if (this.$v.$invalid) {
        this.dob = "";
        this.$toasted.global.my_app_error({
          message: "Please enter correct details",
        });
        // console.log("invalid");
        return;
      }

      await this.checkImage();
      // window.$("#myModal").modal("show");

      // alert("SUCCESS!! :-)\n\n" + JSON.stringify(this.user));
    },
    onFileChangePass(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) {
        return;
      }
      if (files[0].size / 1024 / 1024 > 10) {
        this.$toasted.global.my_app_error({
          message: "Image file size exceeded, Maximum file size allowed is 6MB",
        });
        return;
      }

      this.createpassImage(files[0]);
    },

    onFileChangeSelfie(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) {
        return;
      }
      if (files[0].size / 1024 / 1024 > 10) {
        this.$toasted.global.my_app_error({
          message: "Image file size exceeded, Maximum file size allowed is 6MB",
        });
        return;
      }

      this.createSelfieImage(files[0]);
    },

    onFileChangeNational1(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      if (files[0].size / 1024 / 1024 > 10) {
        this.$toasted.global.my_app_error({
          message: "Image file size exceeded, Maximum file size allowed is 6MB",
        });
        return;
      }
      this.createNationalImage1(files[0]);
    },
    onFileChangeNational2(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      if (files[0].size / 1024 / 1024 > 10) {
        this.$toasted.global.my_app_error({
          message: "Image file size exceeded, Maximum file size allowed is 6MB",
        });
        return;
      }
      this.createNationalImage2(files[0]);
    },
    onFileChangeDriving(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      if (files[0].size / 1024 / 1024 > 10) {
        this.$toasted.global.my_app_error({
          message: "Image file size exceeded, Maximum file size allowed is 6MB",
        });
        return;
      }
      this.createDrivingImage(files[0]);
    },
    createpassImage(file) {
      //var image = new Image();

      // console.log(file)

      var reader = new FileReader();
      let vm = this;
      vm.passImageSubmit = file;

      reader.onload = (e) => {
        vm.passImage = e.target.result;
      };
      reader.readAsDataURL(file);
    },
    createSelfieImage(file) {
      //var image = new Image();

      // console.log(file)

      var reader = new FileReader();
      let vm = this;
      vm.selfieImageSubmit = file;

      reader.onload = (e) => {
        vm.selfieImage = e.target.result;
      };
      reader.readAsDataURL(file);
    },
    removeImagePass: function() {
      this.passImage = "";
    },
    removeImageSelfie: function() {
      this.selfieImage = "";
    },
    removeImageNational1: function() {
      this.nationalImage1 = "";
    },
    removeImageNational2: function() {
      this.nationalImage2 = "";
    },
    removeImageDriving: function() {
      this.drivingImage = "";
    },

    createNationalImage1(file) {
      // var image = new Image();

      var reader = new FileReader();
      let vm = this;
      vm.nationalImage1Submit = file;
      reader.onload = (e) => {
        vm.nationalImage1 = e.target.result;
      };
      reader.readAsDataURL(file);
    },
    createNationalImage2(file) {
      //var image = new Image();

      var reader = new FileReader();
      let vm = this;
      vm.nationalImage2Submit = file;
      reader.onload = (e) => {
        vm.nationalImage2 = e.target.result;
      };
      reader.readAsDataURL(file);
    },
    createDrivingImage(file) {
      //var image = new Image();

      var reader = new FileReader();
      let vm = this;
      vm.drivingImageSubmit = file;

      reader.onload = (e) => {
        vm.drivingImage = e.target.result;
      };
      reader.readAsDataURL(file);
    },
  },

  async created() {
    this.generateNumber();

    this.$store.state.loading = true;
    // var partyEvent = await this.$store.state.KYC.events.addedParty(
    //   {},
    //   { fromBlock: 0 },
    //   async (error, result) => {
    //     if (result) {
    //       this.$store.state.loading = true;
    //       await this.getParties(
    //         result.returnValues.partyName,
    //         result.returnValues.party,
    //         result.returnValues.isSpecial
    //       );
    //       this.$store.state.loading = false;
    //       //await this.$store.dispatch("getCurrentBalance", this.currentAddress);
    //     } else {
    //       console.log(error);
    //     }
    //   }
    // );

    let partyEvents = await this.$store.state.tronWeb.event.getEventsByContractAddress(
      this.$store.state.address,
      { eventName: "addedParty", filters: {}, size: 200 }
    );
    console.log(partyEvents);
    partyEvents = partyEvents.reverse();
    for (let i = 0; i < partyEvents.length; i++) {
      await this.getParties(
        partyEvents[i].result.partyName,
        partyEvents[i].result.party,
        partyEvents[i].result.isSpecial
      );
      // await this.getGov(
      //   govEvents[i].result.country,
      //   this.$store.state.tronWeb.address.fromHex(govEvents[i].result.gov)
      // );
    }
    if (this.$route.params.partyName) {
      if (this.parties.indexOf(this.$route.params.partyName) != -1) {
        console.log(this.$route.params.partyName);
        console.log(this.$refs.partyName);
        this.party = this.$route.params.partyName;
        this.disabled = true;
      } else {
        this.$router.push("/kyc");
      }
    }
    this.$store.state.loading = false;
  },
};
</script>
<style scoped>
@import "../assets/css/style.css";
@import "../assets/css/vendor.bundle.css?ver=104";
@import "../assets/css/style.css?ver=104";

.upload-style {
  border: 2px dotted rgb(185, 184, 184);
  border-radius: 4px;
  background-color: #e0e8f3;
  padding-top: 10px;
  padding-bottom: 20px;
  padding-right: 0;
  padding-left: 0;
  margin: 0;
  align-items: center;
  text-align: center;
}
.dz-message-text {
  color: rgb(112, 111, 111);
  margin-top: 10px;
  margin-bottom: 15px;
}
.dz-message-or {
  color: rgb(112, 111, 111);
}
#file {
  display: inline-block;
  width: 70%;
  margin-top: 20px;
  padding: 120px 0 0 0;
  padding-bottom: 0;
  cursor: pointer;
  height: 100px;
  overflow: hidden;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  background: url("https://cdn1.iconfinder.com/data/icons/hawcons/32/698394-icon-130-cloud-upload-512.png")
    center center no-repeat #fffffff8;
  border-radius: 20px;
  background-size: 60px 60px;
}
#imgstyle {
  width: 30%;
  margin: auto;
  display: block;
  margin-bottom: 10px;
}
</style>
